import { viewProfilePic } from "@/graphql/queries.js";
import { API, graphqlOperation } from "aws-amplify";
import { GenerateS3URL } from "@/mixins/ImageUpload.js";
export const ViewImageDetails = {
  data: () => ({}),
  mixins: [GenerateS3URL],
  mounted() {},
  methods: {
    async ViewImageDetailsMethod(UserId) {
      try {
        this.loading = true;
        var inputParams = {
          user_id: UserId,
        };
        let result = await API.graphql(
          graphqlOperation(viewProfilePic, {
            input: inputParams,
          })
        );
        this.loading = false;
        var ResultObject = JSON.parse(result.data.viewProfilePic);

        if (ResultObject.status == 200) {
          return this.GenerateS3URLMethods(`${ResultObject.profile_pic_url}`);
        }
      } catch (error) {
        console.log("error", error);
        this.loading = false;
        return "ERROR";
      }
    },
  },
};
